import React from "react";
import SubBanner from "./components/SubBanner";
import Follow from "./components/Follow";

function Chocolate() {
  return (
    <>
      <SubBanner title="Chocolate" />

      <section className="shop1-con prod position-relative">
        <div className="container-fluid p-5">

          <div className="row shop-products-con">
            <ProductCard
              image="../assets/product-images/Milk Chocolate.png"
              name="Milk Chocolate"
              desc="Creamy milk chocolate bliss made for every chocolate lover."
            />

            <ProductCard
              image="../assets/product-images/Choco Hazlennut.png"
              name="Choco Hazelnut"
              desc="A luxurious blend of rich chocolate and roasted hazelnut goodness."
            />

            <ProductCard
              image="../assets/product-images/Snickers.png"
              name="Snickers"
              desc="A decadent scoop inspired by the iconic mix of chocolate, nuts, and caramel."
            />

            <ProductCard
              image="../assets/product-images/Plain Chocolate.png"
              name="Plain Chocolate"
              desc="Pure chocolate indulgence with a rich and classic flavour."
            />
          </div>

        </div>
      </section>

      <Follow />
    </>
  );
}

// Product Card
function ProductCard({ image, name, desc }) {
  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
      <div className="classic-box hover-card">
        <div className="classic_image_box box1">
          <img src={image} alt={name} />
        </div>

        <div className="hover-content">
          <h6 className="hover-title">{name}</h6>
          <p className="hover-desc">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default Chocolate;